import type { TNAPIQuery, TNAPIPathParams } from '~/types/napi-helpers'

// forum/bookmark
function listPostBookmarkReactive(
  query: TNAPIQuery<'/napis/v1/discussion/bookmark/posts/', 'get'>,
  asyncDataOptions?: Record<string, any>
) {
  const { openApiReactiveGet } = useAuthFetch()
  return openApiReactiveGet(
    '/napis/v1/discussion/bookmark/posts/',
    undefined,
    query,
    asyncDataOptions
  )
}

// forum/bookmark/comments
function listCommentBookmarkReactive(
  query: TNAPIQuery<'/napis/v1/discussion/bookmark/comment-reply/', 'get'>,
  asyncDataOptions?: Record<string, any>
) {
  const { openApiReactiveGet } = useAuthFetch()
  return openApiReactiveGet(
    '/napis/v1/discussion/bookmark/comment-reply/',
    undefined,
    query,
    asyncDataOptions
  )
}

// used in - ForumPostMenu (bookmark a post)
function bookmarkPost(
  pathParams: TNAPIPathParams<'/napis/v1/discussion/bookmark/post/{post_id_slug}/', 'post'>
) {
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce('/napis/v1/discussion/bookmark/post/{post_id_slug}/', 'post', pathParams)
}

// used in - ForumPostMenu (un-bookmark a post)
function unbookmarkPost(
  pathParams: TNAPIPathParams<'/napis/v1/discussion/bookmark/post/{post_id_slug}/', 'delete'>
) {
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce(
    '/napis/v1/discussion/bookmark/post/{post_id_slug}/',
    'delete',
    pathParams
  )
}

// ForumCommentCard (bookmark a comment)
function bookmarkComment(
  pathParams: TNAPIPathParams<
    '/napis/v1/discussion/bookmark/comment-reply/{comment_reply_id_slug}/',
    'post'
  >
) {
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce(
    '/napis/v1/discussion/bookmark/comment-reply/{comment_reply_id_slug}/',
    'post',
    pathParams
  )
}

// ForumCommentCard (un-bookmark a comment)
function unbookmarkComment(
  pathParams: TNAPIPathParams<
    '/napis/v1/discussion/bookmark/comment-reply/{comment_reply_id_slug}/',
    'delete'
  >
) {
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce(
    '/napis/v1/discussion/bookmark/comment-reply/{comment_reply_id_slug}/',
    'delete',
    pathParams
  )
}

type useForumBookmarkReturnType = {
  listPostBookmarkReactive: typeof listPostBookmarkReactive
  listCommentBookmarkReactive: typeof listCommentBookmarkReactive
  bookmarkPost: typeof bookmarkPost
  unbookmarkPost: typeof unbookmarkPost
  bookmarkComment: typeof bookmarkComment
  unbookmarkComment: typeof unbookmarkComment
}

export function useForumBookmark(): useForumBookmarkReturnType {
  return {
    listPostBookmarkReactive,
    listCommentBookmarkReactive,
    bookmarkPost,
    unbookmarkPost,
    bookmarkComment,
    unbookmarkComment
  }
}
